<template>
    <b-pagination v-model="currentPg" :total-rows="totalRows" :per-page="perPage" first-text="Primeira" prev-text="Anterior"
        next-text="Próxima" last-text="Última" :tableID="tableID" class="mt-2" @page-click="changeCurrentPage">
        <template #first-text>
            <font-awesome-icon icon="angle-double-left" />
        </template>
        <template #prev-text>
            <font-awesome-icon icon="angle-left" />
        </template>
        <template #next-text>
            <font-awesome-icon icon="angle-right" />
        </template>
        <template #last-text>
            <font-awesome-icon icon="angle-double-right" />
        </template>
    </b-pagination>
</template>

<script>
export default {
    name: "table-pagination",
    props: ["totalRows", "perPage", "tableID", "firstCurrentPg"],
    data() {
        return {
            currentPg: this.firstCurrentPg || 1,
        }
    },
    watch: {
        firstCurrentPg(newV) {
            this.currentPg = newV
        }
    },
    methods: {
        changeCurrentPage(bvEvent, page) {
            this.currentPg = page;
            this.$emit('pageChange', this.currentPg, this.tableID);
        }
    }
}
</script>

<style>
.page-item.active .page-link {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    color: #fff !important;
}

.page-link {
    color: #6c757d !important;
    border: 1px solid #6c757d !important;
}
</style>